<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.returnFactoryReworks'), $t('text.list')]">
      </breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.productNo"
            :placeholder="$t('placeholder.productNoCustomerProductNo')"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <vxe-table
        :data="records"
        :loading="loading"
        id="recordsTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="color"
          :title="$t('product.color')"
          min-width="100"
        />
        <vxe-table-column
          field="size"
          :title="$t('product.size')"
          min-width="100"
        />

        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.quantity }}
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="60"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number :content="row.remark" :number="6" />
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="createdAt"
          :title="$t('text.createAt')"
          min-width="110"
        >
          <template v-slot="{ row }">
            {{ row.ownerName }}
            <div class="font10">{{ row.createAt }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="finishAt"
          :title="$t('hang.finishAt')"
          min-width="110"
        >
          <template v-slot="{ row }">
            {{ row.finishName }}
            <div class="font10">{{ row.finishAt }}</div>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span>
          条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { page, table } from "@/utils/mixins.js";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import Rework from "@/api/rework.js";

export default {
  mixins: [
    page,
    table.pager,
    table.search,
    table.narrow,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    RawHtmlLimitNumber,
  },
  data() {
    return {
      narrows: [
        [
          {
            label: this.$t("rework.reworkInfo"),
            items: [
              {
                label: this.$t("reworkInfos.yes"),
                key: "yes",
                condition: { finish: "yes" },
              },
              {
                label: this.$t("reworkInfos.no"),
                key: "no",
                condition: { finish: "no" },
              },
            ],
          },
        ],
      ],
      initFilter: "no",
      searchForm: {
        productNo: null,
      },
      sorter: {
        sortBy: "reworks_id",
        sortIndicator: "desc",
      },
    };
  },
  computed: {
    implicit() {
      return {
        owner: "yes",
        type: "manufacture",
      };
    },
  },

  created() {
    const self = this;
  },
  methods: {
    dataProvider(params) {
      return Rework.search(params);
    },
  },
};
</script>
